import React from "react";

export default (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
        <polygon fill="#0666B0" points="14 34 30 34 30 14 14 14" />
        <polygon fill="#D94453" points="14 50 30 50 30 38 14 38" />
        <polygon fill="#666666" points="34 50 50 50 50 30 34 30" />
        <polygon fill="#CCCCCC" points="34 14 34 26 50 26 50 14" />
    </svg>
)